import { render, staticRenderFns } from "./SecuritySetting.vue?vue&type=template&id=e48ae866&scoped=true"
import script from "./SecuritySetting.vue?vue&type=script&lang=js"
export * from "./SecuritySetting.vue?vue&type=script&lang=js"
import style0 from "./SecuritySetting.vue?vue&type=style&index=0&id=e48ae866&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48ae866",
  null
  
)

export default component.exports